import src from "IMAGE";
export default { src, width: 2346, height: 376, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AP324PX+9uDt+vLc3/Tr1szu5c+36N7IoO3hyIrdz7V12icbL0v/bREAAAAASUVORK5CYII="};
